"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TagDeploymentMode;
(function (TagDeploymentMode) {
    TagDeploymentMode["ContentSquare"] = "CONTENTSQUARE";
    TagDeploymentMode["LoadedByClicktale"] = "LOADED_BY_CLICKTALE";
    TagDeploymentMode["LoadClicktalePtc"] = "LOAD_CLICKTALE_PTC";
    TagDeploymentMode["DualCollectionReview"] = "DUAL_COLLECTION_REVIEW";
    TagDeploymentMode["DualCollection"] = "DUAL_COLLECTION";
})(TagDeploymentMode = exports.TagDeploymentMode || (exports.TagDeploymentMode = {}));
//# sourceMappingURL=tag.deployment.mode.js.map